const DB = "piche_offline";
const STORES = ["queue", "cache"];
let _db;

function open() {
  if (_db) return Promise.resolve(_db);
  return new Promise((res, rej) => {
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => STORES.forEach((s) => { if (!r.result.objectStoreNames.contains(s)) r.result.createObjectStore(s, { keyPath: "key" }); });
    r.onsuccess = () => { _db = r.result; res(_db); };
    r.onerror = () => rej(r.error);
  });
}
function tx(store, mode, fn) {
  return open().then((db) => new Promise((res, rej) => {
    const t = db.transaction(store, mode); const req = fn(t.objectStore(store));
    t.oncomplete = () => res(req && req.result); t.onerror = () => rej(t.error);
  }));
}
export const idb = {
  get: (s, key) => tx(s, "readonly", (st) => st.get(key)).then((r) => r?.value),
  set: (s, key, value) => tx(s, "readwrite", (st) => st.put({ key, value })),
  del: (s, key) => tx(s, "readwrite", (st) => st.delete(key)),
  all: (s) => tx(s, "readonly", (st) => st.getAll()).then((r) => (r || []).map((x) => x.value)),
  supported: typeof indexedDB !== "undefined",
};
